import { Marker, InfoBox } from '@react-google-maps/api'
import { useState } from 'react'

import { type TooltipMarker, getInfoBoxOptions, getMarkerIcon } from './Map'

export function MarkerTooltip({ marker, infoMarker }: TooltipMarker) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Marker
        position={marker.coordinate}
        icon={getMarkerIcon(marker)}
        onMouseOver={() => setIsOpen(true)}
        onMouseOut={() => setIsOpen(false)}
      />
      {isOpen && <InfoBox options={getInfoBoxOptions(infoMarker)}>{infoMarker.children}</InfoBox>}
    </>
  )
}
